<div #reportContainer class="comission-reports-container">
  <!-- SEÇÃO DE FILTROS NO TOPO - IGUAL À OUTRA PÁGINA -->
  <div class="filters-container">
    <span class="filter-label">Filtrar</span>
    <div class="filter-buttons">

      <!-- Componente Exercise Calendar -->
      <app-exercise-calendar [initialYear]="selectedYear" [initialMonth]="selectedMonth"
        (periodChange)="onPeriodChange($event)" [disableEvenMonths]="true" [disabled]="loading"
        [availableExercicios]="availableExercicios">
      </app-exercise-calendar>
    </div>

    <!-- Componente Export Document Button com os períodos do calendário -->
    <app-export-document-button [disabled]="loading" [availableMonths]="availableExercicios"
      [initialStartYear]="selectedYear" [initialStartMonth]="selectedMonth" [initialEndYear]="selectedYear"
      [initialEndMonth]="selectedMonth" (exportDirect)="exportPdfModal()" (exportCancelled)="onExportCancelled()"
      class="export-button">
    </app-export-document-button>
  </div>

  <!-- Mensagem de erro quando exercícios são diferentes -->
  <div *ngIf="exercicioMismatchError" class="error-message-container">
    <div class="error-message">
      <mat-icon class="error-icon">error</mat-icon>
      <span>{{ exercicioMismatchError }}</span>
    </div>
  </div>

  <!-- Mensagem de erro HTTP -->
  <div *ngIf="errorMessage && !loading" class="error-message-container">
    <div class="error-message">
      <mat-icon class="error-icon">error</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="loading-container">
    <div class="loading-spinner"></div>
    <span>Carregando dados...</span>
  </div>

  <!-- Seção Superior -->
  <div class="top-section" *ngIf="!loading && !exercicioMismatchError && !errorMessage">

    <!-- Varejo com tabela e índice lado a lado -->
    <div class="segment-row">
      <!-- Tabela Varejo -->
      <div class="table-card-container">
        <div class="penetration-table-card varejo-card">

          <div class="table-card-header">

            <div class="segment-indicator"></div>
            <h3 class="table-title">Varejo</h3>

          </div>
          <button mat-icon-button class="info-button-outside"
            [attr.data-tooltip]="'As matrizes abaixo representam as negociações de varejo e frota do seu grupo.'">
            <img src="assets/icons/infoIcon.png" alt="Informações" class="info-icon">
          </button>
          <div class="table-card-content">
            <!-- Tabela -->
            <div class="table-wrapper">
              <table class="penetration-table">
                <thead>
                  <tr>
                    <th class="row-header-col">Penetration ↑</th>
                    <th *ngFor="let col of tableColumns" class="data-col">{{ col }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of varejoTableData">
                    <td class="row-header">{{ row.range }}</td>
                    <td *ngFor="let col of tableColumns; let i = index" class="data-cell"
                      [class.highlighted]="isCellHighlighted(row, i)" [class.special-char]="isSpecialCharCell(row, i)"
                      [attr.data-tooltip]="isCellHighlighted(row, i) ? 'Os índices em destaque indicam a projeção de fechamento do próximo período, considerando sua performance atual.' : null">

                      <span *ngIf="!isSpecialCharCell(row, i)">{{ getCellValue(row, i) }}</span>
                      <span *ngIf="isSpecialCharCell(row, i)" class="special-char-symbol">~</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Índice Varejo (AGORA FORA DO CARD, AO LADO) -->
      <div class="indice-card indice-external">
        <div class="indice-header">
          <img src="assets/icons/indexIcon.png" class="trend-icon" alt="Índice">
          <h3 class="indice-title">Índice vigente</h3>
          <!-- Botão de informação após o título Índice vigente -->

        </div>
        <button mat-icon-button class="info-button-index"
          [attr.data-tooltip]="'Estes são os índices de varejo e frota pelos quais seus contratos estão sendo remunerados. O valor pode variar conforme a tabela utilizada.'">
          <img src="assets/icons/infoIcon.png" alt="Informações" class="info-icon">
        </button>
        <div class="indice-metrics">
          <div class="indice-box green">
            <div class="icon-with-label">
              <img src="assets/icons/varejoIcon.png" class="indice-icon" alt="Varejo">
              <span class="icon-label">Varejo</span>
            </div>
            <span class="indice-value">{{ varejoIndice.top.value }}</span>
          </div>
          <div class="indice-box gray">
            <div class="icon-with-label">
              <img src="assets/icons/frotaIcon.png" class="indice-icon-frota" alt="Frota">
              <span class="icon-label">Frota</span>
            </div>
            <span class="indice-value">{{ varejoIndice.bottom.value }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Frota com tabela e índice lado a lado -->
    <div class="segment-row">
      <!-- Tabela Frota -->
      <div class="table-card-container">
        <div class="penetration-table-card frota-card">
          <div class="table-card-header">
            <div class="segment-indicator"></div>
            <h3 class="table-title">Frota</h3>
          </div>

          <div class="table-card-content">
            <!-- Tabela -->
            <div class="table-wrapper">
              <table class="penetration-table">
                <thead>
                  <tr>
                    <th class="row-header-col">Penetration ↑</th>
                    <th *ngFor="let col of tableColumns" class="data-col">{{ col }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of frotaTableData">
                    <td class="row-header">{{ row.range }}</td>
                    <td *ngFor="let col of tableColumns; let i = index" class="data-cell"
                      [class.highlighted]="isCellHighlighted(row, i)" [class.special-icon]="isSpecialIconCell(row, i)"
                      [attr.data-tooltip]="isCellHighlighted(row, i) ? 'Os índices em destaque indicam a projeção de fechamento do próximo período, considerando sua performance atual.' : null">

                      <span *ngIf="!isSpecialIconCell(row, i)">{{ getCellValue(row, i) }}</span>
                      <div *ngIf="isSpecialIconCell(row, i)" class="special-icon-container">
                        <mat-icon class="special-icon-symbol">add_circle</mat-icon>
                        <span>2,58%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Índice Frota (AGORA FORA DO CARD, AO LADO) -->
      <div class="indice-card indice-external">
        <div class="indice-header">
          <img src="assets/icons/indexIcon.png" class="trend-icon" alt="Índice">
          <h3 class="indice-title">Índice para o próximo</h3>
          <!-- Botão de informação após o título Índice para o próximo -->

        </div>
        <button mat-icon-button class="info-button-index"
          [attr.data-tooltip]="'Este índice é resultado da sua performance atual de Penetration e ISR, e aparece em destaque na matriz de comissionamento.'">
          <img src="assets/icons/infoIcon.png" alt="Informações" class="info-icon">
        </button>
        <div class="indice-metrics">
          <div class="indice-box green">
            <div class="icon-with-label">
              <img src="assets/icons/varejoIcon.png" class="indice-icon" alt="Varejo">
              <span class="icon-label">Varejo</span>
            </div>
            <span class="indice-value">{{ frotaIndice.top.value }}</span>
          </div>
          <div class="indice-box gray">
            <div class="icon-with-label">
              <img src="assets/icons/frotaIcon.png" class="indice-icon-frota" alt="Frota">
              <span class="icon-label">Frota</span>
            </div>
            <span class="indice-value">{{ frotaIndice.bottom.value }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Seção Performances -->
  <div class="performances-section" *ngIf="!loading && !exercicioMismatchError && !errorMessage">
    <h2 class="section-title">Performances</h2>

    <div class="performances-content">
      <!-- Charts (Esquerda) -->
      <div class="charts-section">
        <!-- Chart Varejo -->
        <div class="performance-chart-card">
          <div class="chart-header">
            <div class="segment-indicator varejo"></div>
            <h3 class="chart-segment-title">Varejo</h3>
          </div>
          <div class="chart-wrapper">
            <!-- Painel à ESQUERDA - PERÍODO ANTERIOR (MESMO NOME DE CLASSE) -->
            <div class="periodo-atual-panel left-panel">
              <div class="periodo-atual-header">
                <button mat-icon-button class="info-button"
                  [attr.data-tooltip]="'Esses indicadores representam a performance consolidada dos últimos seis meses, referente ao período anterior.'">
                  <img src="assets/icons/infoIcon.png" alt="Informações" class="info-icon">
                </button>
                <span class="periodo-label">Período Anterior</span>
                <span class="periodo-value">{{ varejoPeriodoAnterior.periodo }}</span>
              </div>
              <div class="periodo-metrics">
                <div class="periodo-metric">
                  <span class="periodo-metric-label">Penetration</span>
                  <span class="periodo-metric-value penetration">{{ varejoPeriodoAnterior.penetration }}</span>
                  <!-- Botão de informação após valor do período anterior -->

                </div>
                <div class="periodo-metric">
                  <span class="periodo-metric-label">ISR</span>
                  <span class="periodo-metric-value isr">{{ varejoPeriodoAnterior.isr }}</span>
                </div>
              </div>
            </div>

            <!-- Gráfico no MEIO -->
            <div class="chart-content" *ngIf="isBrowser">
              <!-- Botão de informação na ponta esquerda superior do PRIMEIRO gráfico -->
              <button mat-icon-button class="info-button chart-info-button"
                [attr.data-tooltip]="'A performance de Penetration e ISR apresentada corresponde ao mês fechado, considerando o intervalo de 1 a 31.'">
                <img src="assets/icons/infoIcon.png" alt="Informações" class="info-icon">
              </button>
              <div echarts [options]="varejoPerformanceChart" class="performance-chart"
                (chartInit)="onChartInit($event)"></div>
            </div>

            <!-- Painel à DIREITA - PERÍODO ATUAL -->
            <div class="periodo-atual-panel right-panel">
              <div class="periodo-atual-header">
                <button mat-icon-button class="info-button"
                  [attr.data-tooltip]="'Esses indicadores representam a performance atualizada deste período até a data deste relatório e indicam o índice de comissionamento projetado para o próximo período.'">
                  <img src="assets/icons/infoIcon.png" alt="Informações" class="info-icon">
                </button>
                <span class="periodo-label">Período Atual</span>
                <span class="periodo-value">{{ varejoPeriodoAtual.periodo }}</span>
              </div>
              <div class="periodo-metrics">
                <div class="periodo-metric">
                  <span class="periodo-metric-label">Penetration</span>
                  <span class="periodo-metric-value penetration">{{ varejoPeriodoAtual.penetration }}</span>
                  <!-- Botão de informação após valor do período atual -->

                </div>
                <div class="periodo-metric">
                  <span class="periodo-metric-label">ISR</span>
                  <span class="periodo-metric-value isr">{{ varejoPeriodoAtual.isr }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Chart Frota -->
        <div class="performance-chart-card">
          <div class="chart-header">
            <div class="segment-indicator frota"></div>
            <h3 class="chart-segment-title">Frota</h3>
          </div>
          <div class="chart-wrapper">
            <!-- Painel à ESQUERDA - PERÍODO ANTERIOR (MESMO NOME DE CLASSE) -->
            <div class="periodo-atual-panel left-panel">
              <div class="periodo-atual-header">
                <button mat-icon-button class="info-button"
                  [attr.data-tooltip]="'Esses indicadores representam a performance consolidada dos últimos seis meses, referente ao período anterior.'">
                  <img src="assets/icons/infoIcon.png" alt="Informações" class="info-icon">
                </button>
                <span class="periodo-label">Período Anterior</span>
                <span class="periodo-value">{{ frotaPeriodoAnterior.periodo }}</span>
              </div>
              <div class="periodo-metrics">
                <div class="periodo-metric">
                  <span class="periodo-metric-label">Penetration</span>
                  <span class="periodo-metric-value penetration">{{ frotaPeriodoAnterior.penetration }}</span>
                </div>
                <div class="periodo-metric">
                  <span class="periodo-metric-label">ISR</span>
                  <span class="periodo-metric-value isr">{{ frotaPeriodoAnterior.isr }}</span>
                </div>
              </div>
            </div>

            <!-- Gráfico no MEIO -->
            <div class="chart-content" *ngIf="isBrowser">
              <div echarts [options]="frotaPerformanceChart" class="performance-chart"
                (chartInit)="onChartInit($event)"></div>
            </div>

            <!-- Painel à DIREITA - PERÍODO ATUAL -->
            <div class="periodo-atual-panel right-panel">
              <div class="periodo-atual-header">
                <button mat-icon-button class="info-button"
                  [attr.data-tooltip]="'Esses indicadores representam a performance atualizada deste período até a data deste relatório e indicam o índice de comissionamento projetado para o próximo período.'">
                  <img src="assets/icons/infoIcon.png" alt="Informações" class="info-icon">
                </button>
                <span class="periodo-label">Período Atual</span>
                <span class="periodo-value">{{ frotaPeriodoAtual.periodo }}</span>
              </div>
              <div class="periodo-metrics">
                <div class="periodo-metric">
                  <span class="periodo-metric-label">Penetration</span>
                  <span class="periodo-metric-value penetration">{{ frotaPeriodoAtual.penetration }}</span>
                </div>
                <div class="periodo-metric">
                  <span class="periodo-metric-label">ISR</span>
                  <span class="periodo-metric-value isr">{{ frotaPeriodoAtual.isr }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Métricas (Direita) -->
      <div class="metrics-section">

        <!-- Métricas Varejo -->
        <div class="metrics-card">


          <div class="metric-group">
            <h4 class="metric-group-title"><span class="periodo-value">Período Atual - {{ varejoPeriodoAtual.periodo
                }}</span></h4>
            <button mat-icon-button class="info-button-outside metric-info-button"
              [attr.data-tooltip]="'Compara a performance do seu grupo com as melhores referências do seu Regional e do Brasil.'">
              <img src="assets/icons/infoIcon.png" alt="Informações" class="info-icon">
            </button>
            <div class="metric-boxes">

              <div class="metric-box dark-blue" *ngIf="varejoMetrics.penetration[0]">
                <!-- Botão de informação acima APENAS da primeira métrica -->

                <span class="metric-label">{{ varejoMetrics.penetration[0]?.label }}</span>
                <span class="metric-value">{{ varejoMetrics.penetration[0]?.value }}</span>
              </div>
              <div class="metric-box light-gray" *ngIf="varejoMetrics.penetration[1]">
                <span class="metric-label">{{ varejoMetrics.penetration[1]?.label }}</span>
                <span class="metric-value">{{ varejoMetrics.penetration[1]?.value }}</span>
              </div>
              <div class="metric-box light-green" *ngIf="varejoMetrics.penetration[2]">
                <span class="metric-label">{{ varejoMetrics.penetration[2]?.label }}</span>
                <span class="metric-value">{{ varejoMetrics.penetration[2]?.value }}</span>
              </div>
            </div>
          </div>

          <div class="metric-group">
            <h4 class="metric-group-title">ISR</h4>
            <div class="metric-boxes">
              <div class="metric-box dark-blue" *ngIf="varejoMetrics.isr[0]">
                <span class="metric-label">{{ varejoMetrics.isr[0]?.label }}</span>
                <span class="metric-value">{{ varejoMetrics.isr[0]?.value }}</span>
              </div>
              <div class="metric-box light-gray" *ngIf="varejoMetrics.isr[1]">
                <span class="metric-label">{{ varejoMetrics.isr[1]?.label }}</span>
                <span class="metric-value">{{ varejoMetrics.isr[1]?.value }}</span>
              </div>
              <div class="metric-box light-green" *ngIf="varejoMetrics.isr[2]">
                <span class="metric-label">{{ varejoMetrics.isr[2]?.label }}</span>
                <span class="metric-value">{{ varejoMetrics.isr[2]?.value }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Métricas Frota -->
        <div class="metrics-card">
          <div class="metric-group">
            <h4 class="metric-group-title"><span class="periodo-value">Período Atual - {{ frotaPeriodoAtual.periodo
                }}</span></h4>
            <button mat-icon-button class="info-button-outside metric-info-button"
              [attr.data-tooltip]="'Compara a performance do seu grupo com as melhores referências do seu Regional e do Brasil.'">
              <img src="assets/icons/infoIcon.png" alt="Informações" class="info-icon">
            </button>
            <div class="metric-boxes">
              <div class="metric-box dark-blue" *ngIf="frotaMetrics.penetration[0]">
                <span class="metric-label">{{ frotaMetrics.penetration[0]?.label }}</span>
                <span class="metric-value">{{ frotaMetrics.penetration[0]?.value }}</span>
              </div>
              <div class="metric-box light-gray" *ngIf="frotaMetrics.penetration[1]">
                <span class="metric-label">{{ frotaMetrics.penetration[1]?.label }}</span>
                <span class="metric-value">{{ frotaMetrics.penetration[1]?.value }}</span>
              </div>
              <div class="metric-box light-green" *ngIf="frotaMetrics.penetration[2]">
                <span class="metric-label">{{ frotaMetrics.penetration[2]?.label }}</span>
                <span class="metric-value">{{ frotaMetrics.penetration[2]?.value }}</span>
              </div>
            </div>
          </div>

          <div class="metric-group">
            <h4 class="metric-group-title">ISR</h4>
            <div class="metric-boxes">
              <div class="metric-box dark-blue" *ngIf="frotaMetrics.isr[0]">
                <span class="metric-label">{{ frotaMetrics.isr[0]?.label }}</span>
                <span class="metric-value">{{ frotaMetrics.isr[0]?.value }}</span>
              </div>
              <div class="metric-box light-gray" *ngIf="frotaMetrics.isr[1]">
                <span class="metric-label">{{ frotaMetrics.isr[1]?.label }}</span>
                <span class="metric-value">{{ frotaMetrics.isr[1]?.value }}</span>
              </div>
              <div class="metric-box light-green" *ngIf="frotaMetrics.isr[2]">
                <span class="metric-label">{{ frotaMetrics.isr[2]?.label }}</span>
                <span class="metric-value">{{ frotaMetrics.isr[2]?.value }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Informação de data de fechamento -->
  <div class="closed-date-info" *ngIf="!loading && !exercicioMismatchError">
    Informações válidas de fechamento do Commission Performance até: {{ closedDateCommissionPerformance }}.
  </div>

  <!-- Export Download Modal -->
  <app-export-download-modal
    [show]="showExportModal"
    [fileName]="exportFileName"
    [fileBlob]="exportFileBlob"
    [emailSubject]="exportEmailSubject"
    [emailBody]="exportEmailBody"
    (close)="showExportModal = false"
    (download)="handleExportModalDownload()"
  ></app-export-download-modal>
</div>
